/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OpenCompanyEmailResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }],
} as const;
